// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__sBnf0","requiredAsterisk":"Info_requiredAsterisk__1sfLO"};